import React, { useMemo, useState, Component } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  GridView,
  Icon,
  Widget,
  FormInput,
  FormSubmitButton,
  FormDatePicker,
  FormSelect,
  CompositeView,
  MasterDetailForm,
  FormatText,
  FormTextArea,
  ButtonDelete,
  CrudContext,
  useRouter,
} from '@digital/ui';
import * as areaApi from '@app/api/area';
import { getAllUsuariosMRNAndTerceiroOptions, getAllGerenteAreaOptions } from '@app/api/usuario';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { hasPermission } from '../../helpers/permissions';

const Area = () => {
  const [GetAllItems, setGetAllItems] = useState(() => {
    return areaApi.getAllAreas;
  });

  const { history } = useRouter();

  const onCreateArea = (values: any) => {
    return areaApi.createArea(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => areaApi.getAllAreas);
      }
      return resp;
    });
  };

  const onUpdateArea = (values: any) => {
    return areaApi.updateArea(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => areaApi.getAllAreas);
      }
      return resp;
    });
  };

  return (
    <CrudMasterDetailView
      getAllItems={GetAllItems}
      createItem={hasPermission(['AREA_CADASTRAR']) ? onCreateArea : undefined}
      updateItem={onUpdateArea}
      disableNotification={true}
      icon="business-employee_card"
      detailTitleExtractor={item => `${item.sigla} - ${item.nome}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.diretoria ? item.diretoria.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.sigla ? item.sigla.toLowerCase().startsWith(value.toLowerCase()) : false)
      }
      titleExtractor={item => item.nome}
      descriptionExtractor={item => item.sigla || `${'---' + ' - '}${item.diretoria}`}>
      <CompositeView>
        {hasPermission(['Dono', 'AREA_VISUALIZAR_MENU']) && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              return (
                <GridView noform>
                  <MasterDetailForm
                    validationSchema={Yup.object().shape({
                      nome: Yup.string()
                        .required('Nome deve ser informado')
                        .max(150, 'O nome deve ter no máximo 150 caracteres.'),
                      sigla: Yup.string()
                        .required('Sigla deve ser informada')
                        .max(5, 'A sigla deve ter no máximo 5 caracteres.'),
                      descricao: Yup.string().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
                      diretoriaId: Yup.string().required('Diretoria deve ser informada'),
                    })}>
                    <Widget
                      title="Dados de Área"
                      actions={[
                        selectedItem && hasPermission(['AREA_DELETAR']) && (
                          <ButtonDelete
                            icon={null}
                            type="danger"
                            confirm="Deseja realmente excluir este registro?"
                            okText="Confirmar"
                            onClick={() => {
                              areaApi.deleteArea(selectedItem.id).then((resp: any) => {
                                if (resp.valid) {
                                  setGetAllItems(() => Promise.resolve(undefined));
                                  setGetAllItems(() => areaApi.getAllAreas);
                                  history.push('/areas');
                                }
                                return resp;
                              });
                            }}
                          />
                        ),
                        hasPermission(['AREA_EDITAR', 'AREA_CADASTRAR']) && (
                          <FormSubmitButton noIcon={true} type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                          </FormSubmitButton>
                        ),
                      ]}>
                      <FormInput label="Nome" name="nome" span={6} />
                      <FormInput label="Sigla" name="sigla" span={6} />
                      <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                          return item.props.children.props.id
                            .toString()
                            .toLowerCase()
                            .startsWith(input.toLowerCase());
                        }}
                        label="Responsavel"
                        name="usuarioId"
                        placeholder="Selecione uma opção"
                        getOptions={getAllUsuariosMRNAndTerceiroOptions}
                        span={6}
                      />
                      <FormSelect
                        label="Diretoria"
                        name="diretoriaId"
                        placeholder="Selecione uma opção"
                        required
                        getOptions={getAllDiretoriasOptions}
                        span={6}
                      />
                      <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                          return item.props.children.props.id
                            .toString()
                            .toLowerCase()
                            .startsWith(input.toLowerCase());
                        }}
                        label="Responsável Substituto"
                        name="usuarioSubstitutoId"
                        placeholder="Selecione uma opção"
                        allowClear={true}
                        getOptions={getAllGerenteAreaOptions}
                        span={6}
                      />
                      <FormDatePicker format="DD/MM/YYYY" label="Data Inicial" name="dataInicial" span={3} />
                      <FormDatePicker format="DD/MM/YYYY" label="Data Final" name="dataFinal" span={3} />
                      {/* <FormTextArea label="Descrição" name="descricao" rows={3} /> */}
                    </Widget>
                  </MasterDetailForm>
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default Area;
